/**
 * @generated SignedSource<<474799fbeeeff1a6beda325ddd613334>>
 * @relayHash 95a37fafea41f7393615020271b944eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3de52a71d40720a4d9254d54021b84be0832bdb2474555266267ce6bc5edfe19

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EntitlementsQuery$variables = {
  accountId: string;
  cloudId: string;
};
export type EntitlementsQuery$data = {
  readonly customerService: {
    readonly individualByAccountId: {
      readonly __typename: "CustomerServiceIndividual";
      readonly __id: string;
      readonly entitlementList: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"Entitlement">;
      }>;
      readonly id: string;
      readonly name: string;
    } | {
      readonly __typename: "QueryError";
      readonly " $fragmentSpreads": FragmentRefs<"ThrowOnQueryError">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly productConnections: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "CustomerServiceProduct";
        } | null | undefined;
      }>;
    };
  };
};
export type EntitlementsQuery = {
  response: EntitlementsQuery$data;
  variables: EntitlementsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v9 = [
  (v7/*: any*/),
  (v6/*: any*/)
],
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EntitlementsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v2/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "concreteType": "CustomerServiceProductConnection",
                "kind": "LinkedField",
                "name": "productConnections",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "CustomerServiceProductEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "CustomerServiceProduct",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v4/*: any*/)
                          ]
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "customerService.productConnections.edges"
                  }
                ],
                "storageKey": "productConnections(first:1)"
              },
              "action": "THROW",
              "path": "customerService.productConnections"
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v5/*: any*/),
                "kind": "LinkedField",
                "name": "individualByAccountId",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "RequiredField",
                        "field": (v7/*: any*/),
                        "action": "THROW",
                        "path": "customerService.individualByAccountId.id"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "CustomerServiceEntitlement",
                          "kind": "LinkedField",
                          "name": "entitlementList",
                          "plural": true,
                          "selections": [
                            (v7/*: any*/),
                            {
                              "args": [
                                {
                                  "kind": "Literal",
                                  "name": "includeEntityTypeName",
                                  "value": true
                                }
                              ],
                              "kind": "FragmentSpread",
                              "name": "Entitlement"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "customerService.individualByAccountId.entitlementList"
                      },
                      (v8/*: any*/)
                    ],
                    "type": "CustomerServiceIndividual"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ThrowOnQueryError"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              "action": "THROW",
              "path": "customerService.individualByAccountId"
            }
          ]
        },
        "action": "THROW",
        "path": "customerService"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EntitlementsQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "CustomerServiceProductConnection",
            "kind": "LinkedField",
            "name": "productConnections",
            "plural": false,
            "selections": [
              {
                "concreteType": "CustomerServiceProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "CustomerServiceProduct",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "productConnections(first:1)"
          },
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "individualByAccountId",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "concreteType": "CustomerServiceEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlementList",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "CustomerServiceProduct",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": (v9/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v9/*: any*/),
                            "type": "CustomerServiceOrganization"
                          },
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v8/*: any*/)
                ],
                "type": "CustomerServiceIndividual"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      }
                    ]
                  }
                ],
                "type": "QueryError"
              },
              (v10/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3de52a71d40720a4d9254d54021b84be0832bdb2474555266267ce6bc5edfe19",
    "metadata": {},
    "name": "EntitlementsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "174c0b19de4219e635e33aa462e987e4";

export default node;
